import qs from "qs"

/**
 * Preserve bracket notation for nested Express query parameters while encoding
 * values so reserved URL characters (for example `#` in an import name) are
 * sent to the server instead of being interpreted by the browser.
 */
export default function serializeQueryParams(params: unknown): string {
    return qs.stringify(params, { encodeValuesOnly: true })
}
